import qs from 'qs'
import request from '@/utils/request'
// request.defaults.baseURL = "https://yuanwei333.utools.club";
request.defaults.baseURL = process.env.VUE_APP_GLY_URL;
// request.defaults.baseURL = "http://10.39.0.35:9528";
// request.defaults.baseURL = "http://localhost:9528";


/**
 * 会员指标
 * 
 */
export function membershipIndicators() {
    return request({
      url: '/member/membershipIndicators',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 渠道会员占比
 */
export function proportionChannelMembers() {
    return request({
      url: '/member/proportionChannelMembers',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 会员消费排行
 */
export function memberConsumptionRank() {
    return request({
      url: '/member/memberConsumptionRank',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 活跃会员门店排行接口
 */
export function activeMemberStoreRanking() {
    return request({
      url: '/member/activeMemberStoreRanking',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 *会员结构分析接口
 */
export function analysisMembershipStructure() {
    return request({
      url: '/member/analysisMembershipStructure',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 活跃会员结构分析接口
 */
export function activeMembershipStructure() {
    return request({
      url: '/member/activeMembershipStructure',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 年龄趋势分析接口
 */
export function ageTrendAnalysis() {
    return request({
      url: '/member/ageTrendAnalysis',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 单价购买区间接口
 */
export function unitPricePurchaseRange() {
    return request({
      url: '/member/unitPricePurchaseRange',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 会员等级及活跃度
 */
export function membershipLevelAndActivity() {
    return request({
      url: '/member/membershipLevelAndActivity',
      method: 'get',
      data: qs.stringify({})
    })
}

/**
 * 会员增长流失结构分析
 */
export function increaseAndLossOfMembers() {
    return request({
      url: '/member/increaseAndLossOfMembers',
      method: 'get',
      data: qs.stringify({})
    })
}

